
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/docs/api/products/auth",
      function () {
        return require("private-next-pages/docs/api/products/auth.mdx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/docs/api/products/auth"])
      });
    }
  